import { createSelector } from "reselect";

import selectRights from "./selectRights";

const selectHasRight = createSelector(selectRights, (rights) => (right) => rights.includes(right));

export default selectHasRight;
